<template>
  <div>
    <el-form 
      role="form" 
      @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Select Service Category">
            <el-select
              v-model="labor.serviceCategoryId"
              filterable
              @change="changeServicesByCategory"
            >
              <el-option
                v-for="(item, index) in serviceCategories"
                :key="index"
                :value="item.serviceCategoryId"
                :label="item.label"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Select Service">
            <el-select v-model="labor.serviceId">
              <el-option
                v-for="(item, index) in services"
                :key="index"
                :value="item.serviceId"
                :label="item.label"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input 
            v-uppercase 
            v-model="labor.description" 
            label="Description"/>
        </div>
        <div class="col-md-6">
          <base-input 
            v-model="labor.cost" 
            label="Cost"/>
        </div>
      </div>
      <base-button 
        md 
        type="primary" 
        native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import dateFns from "date-fns";
import { Form, Select, Option } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {
      services: [],
    };
  },

  computed: {
    ...mapState("laborCost", ["labor"]),
    ...mapGetters({
      serviceCategories: "serviceCategory/getServiceCategoryList",
    })
  },
  components: {
    [Form.name]: Form,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  async mounted(){
    this.getServiceCategories();
    if (this.labor.service && this.labor.service.serviceCategoryId) {
      await this.fetchServices(this.labor.service.serviceCategoryId);
    }

  },
  methods: {
    ...mapActions({
      saveLaborCost: "laborCost/saveLaborCost",
      updateLaborCost: "laborCost/updateLaborCost",
      getLaborCosts: "laborCost/getLaborCosts",
      getServiceCategories: "serviceCategory/getServiceCategoryList",
      getServicesByCategoryId: "service/getServicesByCategoryId",
    }),
    onSubmit() {
      if (this.labor.laborCostId) {
        this.updateLaborCost().then(res => {
          this.$notify({
            message: "Cost Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getLaborCosts();
          this.$emit("close");
        this.labor.serviceId = "";
        });
      } else {
        this.saveLaborCost().then(res => {
          this.$notify({
            message: "Cost Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getLaborCosts();
          this.$emit("close");
          this.labor.serviceId = "";
        });
      }
    },
    async changeServicesByCategory(serviceCategoryId) {
      this.labor.serviceId = "";
      this.services = await this.getServicesByCategoryId({ serviceCategoryId });
    },
    async fetchServices(serviceCategoryId) {
      this.services = await this.getServicesByCategoryId({ serviceCategoryId });
      this.labor.serviceId = this.labor.serviceId;
    },
  }
};
</script>